import axios from 'axios';
import { QuestionApiRequest, QuestionApiResponse, FileUploadResponse, Question } from '../types/question';
import { API_CONFIG } from '../config/apiConfig';

export const questionService = {
  /**
   * Upload a file to the server
   * @param file The file to upload
   * @returns Promise with the upload response containing the file URL
   */
  uploadFile: async (file: File): Promise<FileUploadResponse> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post<FileUploadResponse>(
      `${API_CONFIG.BASE_URL}/FileUpload/Upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  /**
   * Save a single question
   * @param question The question data to save
   * @returns Promise with the saved question response
   */
  saveQuestion: async (question: QuestionApiRequest): Promise<QuestionApiResponse> => {
    const response = await axios.post<QuestionApiResponse>(
      `${API_CONFIG.BASE_URL}/Question/SaveQuestion`,
      question
    );
    return response.data;
  },

  /**
   * Get questions for a specific submodule
   * @param subModuleId The ID of the submodule
   * @returns Promise with array of questions
   */
  
  getQuestions: async (subModuleId: number): Promise<Question[]> => {
    try {
      const response = await axios.get<QuestionApiResponse[]>(
        `${API_CONFIG.BASE_URL}/Question/GetQuestions/${subModuleId}`
      );
      // Map API response to UI Question type
      return response.data.map(q => ({
        id: q.id.toString(),
        question: q.questionText,
        options: Array.isArray(q.options) ? q.options : [],
        correctAnswer: Array.isArray(q.options) && typeof q.correctAnswer === 'number'
          ? q.options[q.correctAnswer > 0 ? q.correctAnswer - 1 : -1] || ""
          : "",
        filePath: q.filePath || "",
        sequenceNumber: q.sequenceNumber,
        subModuleId: q.subModuleId,
      }));
    } catch (error) {
      // If there are no questions or any other error, return an empty array
      console.log('No questions found or error occurred:', error);
      return [];
    }
  },

  /**
   * Delete a question
   * @param questionId The ID of the question to delete
   * @returns Promise with the deletion response
   */
  deleteQuestion: async (questionId: number): Promise<void> => {
    await axios.delete(`${API_CONFIG.BASE_URL}/Question/DeleteQuestion/${questionId}`);
  }
}; 